import { createFileRoute } from '@tanstack/react-router';
import styled from 'styled-components';

export const Route = createFileRoute('/usage')({
  component: UsagePage,
});

const PageHeader = styled.div`
  margin-bottom: 24px;
`;

const PageTitle = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 4px;
`;

const PageSubtitle = styled.p`
  font-size: 14px;
  color: #6b7280;
  margin: 0;
`;

const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;
`;

const Card = styled.div`
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 20px 24px;
`;

const CardLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #6b7280;
  margin-bottom: 8px;
`;

const CardValue = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: #9ca3af;
`;

const STATS = [
  { label: 'Unique Visitors (this month)', value: 'Coming soon' },
  { label: 'OTP Verifications (this month)', value: 'Coming soon' },
  { label: 'Current Plan', value: 'Coming soon' },
];

function UsagePage() {
  return (
    <div>
      <PageHeader>
        <PageTitle>Usage & Billing</PageTitle>
        <PageSubtitle>Track unique visitors and OTP verification counts.</PageSubtitle>
      </PageHeader>

      <CardsGrid>
        {STATS.map((stat) => (
          <Card key={stat.label}>
            <CardLabel>{stat.label}</CardLabel>
            <CardValue>{stat.value}</CardValue>
          </Card>
        ))}
      </CardsGrid>
    </div>
  );
}
